export function formatCommonAbbreviations (value) {
  const result = value
    .replace(/\bid\b/ig, 'ID')
    .replace(/\biban\b/ig, 'IBAN')
    .replace(/\biso\b/ig, 'ISO')
    .replace(/\bpd\b/ig, 'Personal data')
    .replace(/\bsmt\b/ig, 'SMT')
  return result
}
